import useSWR, { mutate } from 'swr';
import * as RequestApi from '~/api/request';

export default useActiveOrdersCount;
export { incrementActiveOrders, decrementActiveOrders };

/**
 * Gets the count from the node server.
 * @returns
 */
function useActiveOrdersCount() {
  const result = useSWR('/api/orders/active-order-count', RequestApi.defaultSWRGetter);
  const data = result?.data?.data;
  return {
    activeOrderCount: data ? data.activeOrderCount : 0,
  };
}

/**
 * Increment the count oun the client side. This DOES NOT
 * persist the count! This is a nicety to help the UI
 * stay in sync when orders are placed
 */
function incrementActiveOrders() {
  async function increment(data) {
    const current = data.activeOrderCount;
    return {
      activeOrderCount: current + 1,
    };
  }
  mutate('/api/orders/active-order-count', increment);
}

/**
 * Decrement the count oun the client side. This DOES NOT
 * persist the count! This is a nicety to help the UI
 * stay in sync when orders are canceled
 */
function decrementActiveOrders() {
  async function increment(data) {
    const current = data.activeOrderCount;
    const newCount = current - 1 || 0;
    return {
      activeOrderCount: newCount,
    };
  }
  mutate('/api/orders/active-order-count', increment);
}
